<template>
  <div>
    <div class="about">
      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../assets/about/about-back-one.png" style="width: 100%;min-height: 500px;" />
            <div class="carousel-caption">
              <div class="header-container">
                <div class="header-all-container">
                  <div class="header-top">
                    <div class="header-top-left">
                      <div class="img-responsives">
                        <img src="../assets/logo.png" style="width: 100%; height: auto;" />
                      </div>
                      <div class="header-top-left-img-font">
                        <p class="header-top-left-font-style header-top-font-symbol"
                          style="margin: 0 10px;color: #fff;">|
                        </p>
                        <p class="header-top-left-font-style" style="margin: 0;color: #fff;">河北任氏科技有限公司</p>
                      </div>
                    </div>
                    <div class="header-top-right">
                      <nav class="navbar navbar-fixed-center navbar-inverse navbar-expand-lg">
                        <div class="container-fluid">
                          <div class="navbar-header">
                            <button class="navbar-toggle" data-target="#menu">
                              <img src="../assets/line.png" style="width: 25px;height:25px" />
                            </button>
                            <a href="#" class="navbar-brand"></a>
                          </div>
                          <div id="menu" class="navbar-collapse">
                            <ul class="nav navbar-nav">
                              <li class="nav-item min-liHome">
                                <router-link to="/" style="height: 80px;display: inline-block;">
                                  <span class="span-style active">关于我们</span>
                                </router-link>
                              </li>
                              <li class="nav-item min-liHome">
                                <router-link to="/product" style="height: 80px;display: inline-block;">
                                  <span class="span-style">产品与解决方案</span>
                                </router-link>
                              </li>
                              <li class="nav-item min-liHome">
                                <router-link to="/technology" style="height: 80px;display: inline-block;">
                                  <span class="span-style">技术支持</span>
                                </router-link>
                              </li>
                              <li class="nav-item min-liHome">
                                <router-link to="/contact" style="height: 80px;display: inline-block;">
                                  <span class="span-style">联系我们</span>
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </nav>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
              <div class="about-top-body-container">
                <p class="about-top-body-container-first-font">智现在<span
                    class="about-top-body-container-first-font-coll"></span>共未来</p>
                <p class="about-top-body-container-second-font">
                  <span class="font-one">以管理求效益<span style="margin: 0 10px;">|</span>以质量求生存</span>
                  <span class="font-two" style="margin: 0 10px;">|</span>
                  <span class="font-three">
                    以服务建友谊<span style="margin: 0 10px;">|</span>以实干为效益
                  </span>
                </p>
                <div class="about-top-body-container-img">
                  <img class="img-one" src="../assets/about/home-1.png" />
                  <img class="img-two" src="../assets/about/home-2.png" />
                  <img class="img-three" src="../assets/about/home-3.png" />
                  <img class="img-four" src="../assets/about/home-4.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about-three-container">
        <p class="about-two-container-font-one" style="color: #fff;">产品与解决方案</p>
        <div class="about-two-container-font-two">
          <p class="two-p-line-style-one"></p>
          <p style="color: #999;">提供多种类型产品服务，全方位功能支持</p>
          <p class="two-p-line-style-two"></p>
        </div>
        <div class="product-list">
          <div class="row">
            <div class="product-list-one col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="product-list-one-container"></div>
              <div class="product-list-one-no-font">
                <p style="color: #fff;font-size: 24px;">蜂仆智慧社区</p>
              </div>
              <div class="product-list-one-selected-font">
                <p style="color: #fff;font-size: 22px;">蜂仆智慧社区</p>
                <div style="margin: 30px 0;text-align: center;">
                  <p style="width: 30px;height: 2px;margin-left: 40%;background-color: #fff;"></p>
                </div>
                <p style="width: 250px;color: #fff;font-size: 16px;text-align: left;">
                  <span>蜂仆智慧社区生活服务平台，集快递配送跟踪、在线物业缴费、电话费用秒充等多功能于一体，让居民享受安全、便捷的智慧化生活体验，提升社区管理效率，构建和谐宜居的未来社区。</span>
                </p>
              </div>
            </div>
            <div class="product-list-two col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="product-list-two-container"></div>
              <div class="product-list-two-no-font">
                <p style="color: #fff;font-size: 24px;">共享WIFI</p>
              </div>
              <div class="product-list-two-selected-font">
                <p style="color: #fff;font-size: 22px;">共享WIFI</p>
                <div style="margin: 30px 0;text-align: center;">
                  <p style="width: 30px;height: 2px;margin-left: 40%;background-color: #fff;"></p>
                </div>
                <p style="width: 250px;margin-top: 20px;color: #fff;font-size: 16px;text-align: left;">
                  <span>共享WiFi小程序，一键自动连周边热点，无需密码，便捷上网。观看趣味广告，轻松赚取收益，让每次网络连接都收获满满。我们矢志打造更智能、盈利的上网体验，赋予每一步连接更多价值。</span>
                </p>
              </div>
            </div>
            <div class="product-list-three col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="product-list-three-container"></div>
              <div class="product-list-three-no-font">
                <p style="color: #fff;font-size: 24px;">电商运营</p>
              </div>
              <div class="product-list-three-selected-font">
                <p style="color: #fff;font-size: 22px;">电商运营</p>
                <div style="margin: 30px 0;text-align: center;">
                  <p style="width: 30px;height: 2px;margin-left: 40%;background-color: #fff;"></p>
                </div>
                <p style="width: 250px;color: #fff;font-size: 16px;text-align: left;">
                  <span>专业电商运营支持，深度剖析店铺与商品，助力您在拼多多、淘宝、抖音等多平台驰骋。我们提供高效链接工具，优化运营策略，解锁流量密码，提升销量与品牌影响力。精准数据洞察，让每一步决策都有的放矢，成就电商辉煌。</span>
                </p>
              </div>
            </div>
            <div class="product-list-four col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="product-list-four-container"></div>
              <div class="product-list-four-no-font">
                <p style="color: #fff;font-size: 24px;">娱乐直播</p>
              </div>
              <div class="product-list-four-selected-font">
                <p style="color: #fff;font-size: 22px;">娱乐直播</p>
                <div style="margin: 30px 0;text-align: center;">
                  <p style="width: 30px;height: 2px;margin-left: 40%;background-color: #fff;"></p>
                </div>
                <p style="width: 250px;color: #fff;font-size: 16px;text-align: left;">
                  <span>一站式娱乐直播解决方案专家。我们专注于娱乐互动程序定制开发，辅以主播专业孵化体系，结合创意内容策划与多渠道推广策略，为直播平台注入活力，打造爆款内容，引领娱乐风潮，实现流量与收益的双重飞跃。</span>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="product-list-five col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="product-list-five-container"></div>
              <div class="product-list-five-no-font">
                <p style="color: #fff;font-size: 24px;">移动端APP</p>
              </div>
              <div class="product-list-five-selected-font">
                <p style="color: #fff;font-size: 22px;">移动端APP</p>
                <div style="margin: 30px 0;text-align: center;">
                  <p style="width: 30px;height: 2px;margin-left: 40%;background-color: #fff;"></p>
                </div>
                <p style="width: 250px;color: #fff;font-size: 16px;text-align: left;">
                  <span>好的UI设计不仅是让软件变得有个性有品位，还要让软件的操作变得舒适简单、自由，充分体现软件的定位和特点。</span>
                </p>
              </div>
            </div>
            <div class="product-list-six col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="product-list-six-container"></div>
              <div class="product-list-six-no-font">
                <p style="color: #fff;font-size: 24px;">WEB网站</p>
              </div>
              <div class="product-list-six-selected-font">
                <p style="color: #fff;font-size: 22px;">WEB网站</p>
                <div style="margin: 30px 0;text-align: center;">
                  <p style="width: 30px;height: 2px;margin-left: 40%;background-color: #fff;"></p>
                </div>
                <p style="width: 250px;color: #fff;font-size: 16px;text-align: left;">
                  <span>建立在Internet上的一种网络服务，我司致力于为浏览者在Internet上查找和浏览信息提供图形化的、易于访问的直观界面。</span>
                </p>
              </div>
            </div>
            <div class="product-list-seven col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="product-list-seven-container"></div>
              <div class="product-list-seven-no-font">
                <p style="color: #fff;font-size: 24px;">微信小程序</p>
              </div>
              <div class="product-list-seven-selected-font">
                <p style="color: #fff;font-size: 22px;">微信小程序</p>
                <div style="margin: 30px 0;text-align: center;">
                  <p style="width: 30px;height: 2px;margin-left: 40%;background-color: #fff;"></p>
                </div>
                <p style="width: 250px;color: #fff;font-size: 16px;text-align: left;">
                  <span>小程序是一种新的开放能力，我司将助力商家打造营销闭环，依托以微信为代表的全域领域。</span>
                </p>
              </div>
            </div>
            <div class="product-list-eight col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="product-list-eight-container"></div>
              <div class="product-list-eight-no-font">
                <p style="color: #fff;font-size: 24px;">敬请期待</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about-four-container" style="background-color: #f2f5f7;">
        <p class="about-two-container-font-one">合作案例</p>
        <div class="about-two-container-font-two">
          <p class="p-line-style-one"></p>
          <p>让优秀的企业更加优秀</p>
          <p class="p-line-style-two"></p>
        </div>
        <div>
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation01.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation02.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation03.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation04.png" class="row-img" />
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation05.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation06.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation07.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation08.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation09.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation10.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation11.png" class="row-img" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px;">
              <img src="../assets/about/cooperation12.png" class="row-img" />
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>
<script>
  import Footer from "../components/footer";
  import $ from "jquery"
  export default {
    components: {
      Footer
    },
    mounted() {
      $('.navbar-toggle').click(function () {
        if ($('#menu').css('display') == 'none') {
          $('#menu').css('display', 'block');
        } else if ($('#menu').css('display') == 'block') {
          $('#menu').css('display', 'none');
        };
        if ($('#menu2').css('display') == 'none') {
          $('#menu2').css('display', 'block');
        } else if ($('#menu2').css('display') == 'block') {
          $('#menu2').css('display', 'none');
        };
        if ($('#menu3').css('display') == 'none') {
          $('#menu3').css('display', 'block');
        } else if ($('#menu3').css('display') == 'block') {
          $('#menu3').css('display', 'none');
        };
        if ($('#menu4').css('display') == 'none') {
          $('#menu4').css('display', 'block');
        } else if ($('#menu4').css('display') == 'block') {
          $('#menu4').css('display', 'none');
        };
      })
    }
  }
</script>
<style lang="scss" scoped>
  .navbar-toggle {
    position: absolute;
    top: 0;
    right: 10px;
    display: none;
  }

  .navbar {
    padding: 0 !important;
    padding-top: 10px !important;
  }

  a {
    color: #fff !important;
  }

  a:hover {
    color: #fff !important;
    text-decoration: none !important;
  }

  a:link {
    color: #fff !important;
    text-decoration: none !important;
  }

  .span-style {
    color: #bbb;
  }

  .row {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .carousel-caption {
    right: 0 !important;
    left: 0 !important;
    padding-bottom: 0 !important;
  }

  .carousel-caption {
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    padding-top: 0 !important;
  }

  .carousel-indicators {
    left: 25% !important;
  }

  .carousel-indicators li {
    border-radius: 50%;
  }

  .about-top-body-container-first-font,
  .about-top-body-container-second-font {
    color: #fff;
  }

  .about-two-container,
  .about-four-container {
    width: 100%;
    background-color: #fff;
    text-align: center;
  }

  .about-two-container-font-two {
    color: #666;
  }

  .p-line-style-one {
    width: 150px;
    height: 2px;
    margin-top: 15px;
    margin-right: 15px;
    background: -moz-linear-gradient(right, #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, right, left, color-stop(0%, #000000), color-stop(100%, #ffffff));
    background: -webkit-linear-gradient(right, #000000 0%, #ffffff 100%);
    background: -o-linear-gradient(right, #000000 0%, #ffffff 100%);
    background: -ms-linear-gradient(right, #000000 0%, #ffffff 100%);
    background: linear-gradient(to left, #000000 0%, #ffffff 100%);
  }

  .p-line-style-two {
    width: 150px;
    height: 2px;
    margin-top: 15px;
    margin-left: 15px;
    background: -moz-linear-gradient(left, #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left, right, color-stop(0%, #000000), color-stop(100%, #ffffff));
    background: -webkit-linear-gradient(left, #000000 0%, #ffffff 100%);
    background: -o-linear-gradient(left, #000000 0%, #ffffff 100%);
    background: -ms-linear-gradient(left, #000000 0%, #ffffff 100%);
    background: linear-gradient(to right, #000000 0%, #ffffff 100%);
  }

  .about-three-container {
    width: 100%;
    background: url('../assets/about/product-background.png') repeat;
    text-align: center;
  }

  .two-p-line-style-one {
    width: 150px;
    height: 2px;
    margin-top: 15px;
    margin-right: 15px;
    background: -moz-linear-gradient(left, transparent 0%, #bbb 100%);
    background: -webkit-gradient(linear, left, right, color-stop(0%, transparent), color-stop(100%, #bbb));
    background: -webkit-linear-gradient(left, transparent 0%, #bbb 100%);
    background: -o-linear-gradient(left, transparent 0%, #bbb 100%);
    background: -ms-linear-gradient(left, transparent 0%, #bbb 100%);
    background: linear-gradient(to right, transparent 0%, #bbb 100%);
  }

  .two-p-line-style-two {
    width: 150px;
    height: 2px;
    margin-top: 15px;
    margin-left: 15px;
    background: -moz-linear-gradient(right, transparent 0%, #bbb 100%);
    background: -webkit-gradient(linear, right, left, color-stop(0%, transparent), color-stop(100%, #bbb));
    background: -webkit-linear-gradient(right, transparent 0%, #bbb 100%);
    background: -o-linear-gradient(right, transparent 0%, #bbb 100%);
    background: -ms-linear-gradient(right, transparent 0%, #bbb 100%);
    background: linear-gradient(to left, transparent 0%, #bbb 100%);
  }

  .product-list {
    margin-top: 50px;
  }

  .product-list-one,
  .product-list-two,
  .product-list-three,
  .product-list-four,
  .product-list-five,
  .product-list-six,
  .product-list-seven,
  .product-list-eight {
    /* width: 20%; */
    height: 360px;
    margin-top: 20px;
    position: relative;
  }

  .product-list-one-container,
  .product-list-two-container,
  .product-list-three-container,
  .product-list-four-container,
  .product-list-five-container,
  .product-list-six-container,
  .product-list-seven-container,
  .product-list-eight-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
  }

  .product-list-one-no-font,
  .product-list-two-no-font,
  .product-list-three-no-font,
  .product-list-four-no-font,
  .product-list-five-no-font,
  .product-list-six-no-font,
  .product-list-seven-no-font,
  .product-list-eight-no-font {
    position: absolute;
    top: 45%;
    left: 0;
    right: 0;
    margin: auto;
  }

  .product-list-one-selected-font,
  .product-list-two-selected-font,
  .product-list-three-selected-font,
  .product-list-four-selected-font,
  .product-list-five-selected-font,
  .product-list-six-selected-font,
  .product-list-seven-selected-font {
    position: absolute;
    top: 15%;
    left: 50%;
    margin-left: -125px;
    display: none;

  }

  .product-list-one {
    background: url('../assets/about/01-1.png') center center no-repeat;
  }

  .product-list-one:hover .product-list-one-container {
    opacity: 0.5;
    background: url('../assets/about/selected.png') center center no-repeat;
    /* background-size: 100% 100%; */
  }

  .product-list-one:hover .product-list-one-no-font {
    display: none;
  }

  .product-list-one:hover .product-list-one-selected-font {
    display: block;
  }


  .product-list-two {
    background: url('../assets/about/02-1.png') center center no-repeat;

  }

  .product-list-two:hover .product-list-two-container {
    opacity: 0.5;
    background: url('../assets/about/selected.png') center center no-repeat;
    /* background-size: 100% 100%; */
  }

  .product-list-two:hover .product-list-two-no-font {
    display: none;
  }

  .product-list-two:hover .product-list-two-selected-font {
    display: block;
  }

  .product-list-three {
    background: url('../assets/about/03-1.png') center center no-repeat;

  }

  .product-list-three:hover .product-list-three-container {
    opacity: 0.5;
    background: url('../assets/about/selected.png') center center no-repeat;
    /* background-size: 100% 100%; */
  }

  .product-list-three:hover .product-list-three-no-font {
    display: none;
  }

  .product-list-three:hover .product-list-three-selected-font {
    display: block;
  }

  .product-list-four {
    background: url('../assets/about/04-1.png') center center no-repeat;

  }

  .product-list-four:hover .product-list-four-container {
    opacity: 0.5;
    background: url('../assets/about/selected.png') center center no-repeat;
    /* background-size: 100% 100%; */
  }

  .product-list-four:hover .product-list-four-no-font {
    display: none;
  }

  .product-list-four:hover .product-list-four-selected-font {
    display: block;
  }

  .product-list-five {
    background: url('../assets/about/05-1.png') center center no-repeat;

  }

  .product-list-five:hover .product-list-five-container {
    opacity: 0.5;
    background: url('../assets/about/selected.png') center center no-repeat;
    /* background-size: 100% 100%; */
  }

  .product-list-five:hover .product-list-five-no-font {
    display: none;
  }

  .product-list-five:hover .product-list-five-selected-font {
    display: block;
  }

  .product-list-six {
    background: url('../assets/about/06-1.png') center center no-repeat;

  }

  .product-list-six:hover .product-list-six-container {
    opacity: 0.5;
    background: url('../assets/about/selected.png') center center no-repeat;
    /* background-size: 100% 100%; */
  }

  .product-list-six:hover .product-list-six-no-font {
    display: none;
  }

  .product-list-six:hover .product-list-six-selected-font {
    display: block;
  }

  .product-list-seven {
    background: url('../assets/about/07-1.png') center center no-repeat;

  }

  .product-list-seven:hover .product-list-seven-container {
    opacity: 0.5;
    background: url('../assets/about/selected.png') center center no-repeat;
    /* background-size: 100% 100%; */
  }

  .product-list-seven:hover .product-list-seven-no-font {
    display: none;
  }

  .product-list-seven:hover .product-list-seven-selected-font {
    display: block;
  }

  .product-list-eight {
    background: url('../assets/about/08-1.png') center center no-repeat;

  }


  @media screen and (min-width: 1781px) {
    .about-top-body-container {
      padding: 13% 15%;

    }

    .about-top-body-container-first-font {
      font-size: 80px;
      font-weight: bold;
    }

    .about-top-body-container-first-font-coll {
      margin: 0 30px;
    }

    .about-top-body-container-second-font {
      font-size: 24px;
    }

    .about-top-body-container-img {
      /* width: 85%; */
      width: 90%;
      margin: 0 auto;
      margin-top: 50px;
      /* padding: 5px;
    background-color: rgba(225, 225, 225, 0.2);
    border-radius: 5px; */
    }

    .about-top-two-body-container {
      width: 90%;
      margin: 0 auto;
      padding: 10% 0;
      display: flex;
      justify-content: space-between;
    }

    .top-two-font-center {
      font-size: 24px;
    }

    .top-two-font-img,
    .top-two-font-img2 {
      width: 500px;
      height: 500px;
    }

    .about-top-three-body-container {
      padding: 10% 15%;
    }

    .about-two-container {
      padding: 5%;
    }

    .about-three-container {
      padding: 4%;
    }

    .about-four-container {
      padding: 5% 10%;
    }

    .about-two-container-font-one {
      font-size: 36px;
    }

    .about-two-container-font-two {
      width: 35%;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 50px;
      display: flex;
      justify-content: space-around;
      font-size: 20px;
    }
  }

  @media screen and (min-width: 1200px) and (max-width: 1780px) {
    .about-top-body-container {
      padding: 10% 15%;
    }

    .about-top-body-container-first-font {
      font-size: 70px;
      font-weight: bold;
    }

    .about-top-body-container-first-font-coll {
      margin: 0 30px;
    }

    .about-top-body-container-second-font {
      font-size: 24px;
    }

    .about-top-body-container-img {
      width: 100%;
      margin: 0 auto;
      margin-top: 50px;
      padding: 5px;
      background-color: rgba(225, 225, 225, 0.2);
      border-radius: 5px;
    }

    .img-one,
    .img-two,
    .img-three {
      width: 25%;
    }

    .img-four {
      width: 20%;
    }

    .about-top-two-body-container {
      width: 90%;
      margin: 0 auto;
      padding: 10% 0;
      display: flex;
      justify-content: space-between;
    }

    .top-two-font-center {
      font-size: 24px;
    }

    .top-two-font-img {
      width: 400px;
      height: 400px;
    }

    .top-two-font-img2 {
      width: 350px;
      height: 350px;
    }

    .about-top-three-body-container {
      padding: 10%;
    }

    .about-two-container {
      padding: 5% 20%;
    }

    .about-three-container {
      padding: 5% 1%;
    }

    .about-four-container {
      padding: 5%;
    }

    .about-two-container-font-one {
      font-size: 36px;
    }

    .about-two-container-font-two {
      width: 60%;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 50px;
      display: flex;
      justify-content: space-around;
      font-size: 20px;
    }

    .row-img {
      width: 300px;
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1199px) {
    .about-top-body-container {
      padding: 10% 15%;
    }

    .about-top-body-container-first-font {
      font-size: 50px;
      font-weight: bold;
    }

    .about-top-body-container-first-font-coll {
      margin: 0 20px;
    }

    .about-top-body-container-second-font {
      font-size: 20px;
    }

    .about-top-body-container-img {
      width: 100%;
      margin: 0 auto;
      margin-top: 50px;
      padding: 5px;
      background-color: rgba(225, 225, 225, 0.2);
      border-radius: 5px;
    }

    .img-one,
    .img-two,
    .img-three {
      width: 25%;
    }

    .img-four {
      width: 20%;
    }

    .about-top-two-body-container {
      width: 90%;
      margin: 0 auto;
      padding: 10% 0;
      display: flex;
      justify-content: space-between;
    }

    .top-two-font-center {
      font-size: 24px;
    }

    .top-two-font-img {
      width: 450px;
      height: 550px;
    }

    .top-two-font-img2 {
      width: 300px;
      height: 300px;
    }

    .about-top-three-body-container {
      padding: 8%;
    }

    .about-two-container {
      padding: 5% 20%;
    }

    .about-three-container {
      padding: 5% 1%;
    }

    .about-four-container {
      padding: 5% 3%;
    }

    .about-two-container-font-one {
      font-size: 36px;
    }

    .about-two-container-font-two {
      width: 60%;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 50px;
      display: flex;
      justify-content: space-around;
      font-size: 20px;
    }

    .row-img {
      width: 300px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
    .about-top-body-container {
      padding: 8% 15%;
    }

    .about-top-body-container-first-font {
      font-size: 40px;
      font-weight: bold;
    }

    .about-top-body-container-first-font-coll {
      margin: 0 20px;
    }

    .about-top-body-container-second-font {
      font-size: 18px;
    }

    .about-top-body-container-img {
      width: 100%;
      margin: 0 auto;
      margin-top: 40px;
      padding: 5px;
      background-color: rgba(225, 225, 225, 0.2);
      border-radius: 5px;
    }

    .img-one,
    .img-two,
    .img-three {
      width: 25%;
    }

    .img-four {
      width: 20%;
    }

    .about-top-two-body-container {
      width: 90%;
      margin: 0 auto;
      padding: 6% 0;
      display: flex;
      justify-content: space-between;
    }

    .top-two-font-center {
      font-size: 19px;
    }

    .top-two-font-img {
      width: 450px;
      height: 550px;
    }

    .top-two-font-img2 {
      width: 300px;
      height: 300px;
    }

    .about-top-three-body-container {
      padding: 5%;
    }

    .about-two-container {
      padding: 5% 20%;
    }

    .about-three-container {
      padding: 5% 1%;
    }

    .about-four-container {
      padding: 5% 1%;
    }

    .about-two-container-font-one {
      font-size: 30px;
    }

    .about-two-container-font-two {
      width: 90%;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 50px;
      display: flex;
      justify-content: space-around;
      font-size: 18px;
    }

    .row-img {
      width: 300px;
    }
  }

  /* and (min-width: 576px)  */
  @media screen and (max-width: 767px) {
    .about-top-body-container {
      padding: 15% 1%;
    }

    .product-list-one,
    .product-list-two,
    .product-list-three,
    .product-list-four,
    .product-list-five,
    .product-list-six,
    .product-list-seven,
    .product-list-eight {
      width: 80% !important;
      margin: 0 auto;
      margin-top: 20px;
    }

    .about-top-body-container-first-font {
      font-size: 28px;
      font-weight: bold;
    }

    .about-top-body-container-first-font-coll {
      margin: 0 10px;
    }

    .about-top-body-container-second-font {
      font-size: 14px;
    }

    .font-one {
      display: block;
    }

    .font-two {
      display: none;
    }

    .font-three {
      display: block;
    }

    .about-top-body-container-img {
      width: 100%;
      margin: 0 auto;
      margin-top: 30px;
      padding: 5px;
      background-color: rgba(225, 225, 225, 0.2);
      border-radius: 5px;
    }

    .img-one,
    .img-two,
    .img-three {
      width: 25%;
    }

    .img-four {
      width: 20%;
    }

    .about-top-two-body-container {
      width: 100%;
      margin: 0 auto;
      padding: 8%;
    }

    .top-two-font-center {
      font-size: 18px;
    }

    .top-two-font-img {
      width: 250px;
      height: 120px;
      margin: 0 auto;
      margin-top: 20px;
      text-align: center;
    }

    .top-two-font-img2 {
      width: 250px;
      height: 120px;
      margin: 0 auto;
      margin-top: 20px;
      text-align: center;
    }

    .top-two-font-img2 img {
      width: 165px !important;
      height: 120px !important;
    }

    .about-top-three-body-container {
      padding: 10%;
    }

    .about-two-container {
      padding: 7%;
    }

    .about-three-container {
      padding: 5% 1%;
    }

    .about-four-container {
      padding: 5% 1%;
    }

    .about-two-container-font-one {
      font-size: 22px;
    }

    .about-two-container-font-two {
      width: 100%;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 50px;
      display: flex;
      justify-content: space-around;
      font-size: 14px;
    }

    .row-img {
      width: 300px;
    }

    /* .carousel-control-prev,
  .carousel-control-next {
    width: 7% !important;
  } */
  }

  .carousel-indicators li {
    width: 12px !important;
    height: 12px !important;
    margin-right: 10px !important;
  }

  @media (min-width: 992px) {

    .product-list-one,
    .product-list-two,
    .product-list-three,
    .product-list-four,
    .product-list-five,
    .product-list-six,
    .product-list-seven,
    .product-list-eight {
      margin-right: 8px;
    }

    .col-lg-3 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 25%;
      flex: 0 0 24% !important;
      max-width: 25%;
    }
  }

  .header-container {
    width: 100%;
    /* background: url('../assets/about-back-one.png');
  background-position: top center;
  background-size: cover; */
  }

  #menu,
  #menu2,
  #menu3,
  #menu4 {
    display: none;
  }

  .header-all-container {
    height: 100px;
    // line-height: 100px;
    border-bottom: 1px solid #fff;
  }

  .header-top {
    width: 95%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

  }

  .nav>li>a {
    padding: 0 !important;
  }

  .navbar-brand {
    height: 0 !important;
  }

  .navbar-inverse {
    background-color: transparent !important;
    border-color: transparent !important;
  }

  .nav-link {
    padding: 0;
  }

  a:hover {
    text-decoration: none;
  }

  .navbar-inverse .navbar-nav>.active>a,
  .navbar-inverse .navbar-nav>.active>a:focus,
  .navbar-inverse .navbar-nav>.active>a:hover {
    background-color: transparent !important;
  }

  .span-style {
    color: #bbb;
  }

  @media screen and (min-width: 1000px) {
    .navbar-collapse.collapse {
      display: none !important;
      height: auto !important;
      padding-bottom: 0;
      overflow: visible !important;
    }
  }

  @media screen and (min-width: 1781px) {
    .header-container {
      padding-top: 70px;
    }

    .img-responsives {
      width: auto;
      height: 70px;
    }

    .header-top-left {
      height: 80px;
      line-height: 80px;
      display: flex;
    }

    .header-top-left-img-font {
      padding-top: 10px;
      display: flex;
    }

    .header-top-left-font-style {
      font-size: 30px;
    }

    .nav-item {
      width: 165px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    .min-liHome {
      // padding-top: 30px;
      color: #bbb;
      font-size: 23px;
    }

    .min-liHome:hover {
      border-bottom: 6px transparent solid;
      border-image: linear-gradient(to right, rgb(22, 115, 202), #0aa1ed) 1 10;
      cursor: pointer;
    }

    .navbar-nav {
      float: right !important;
    }
  }

  @media screen and (min-width: 1200px) and (max-width: 1780px) {
    .header-container {
      padding-top: 70px;
    }

    .img-responsives {
      width: 180px;
      height: 60px;
    }

    .header-top-left {
      height: 80px;
      line-height: 80px;
      display: flex;
    }

    .header-top-left-img-font {
      padding-top: 10px;
      display: flex;
    }

    .header-top-left-font-style {
      font-size: 21px;
    }

    .nav-item {
      width: 140px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    .min-liHome {
      // padding-top: 30px;
      font-size: 20px;
      color: #bbb;
    }

    .min-liHome:hover {
      border-bottom: 6px transparent solid;
      border-image: linear-gradient(to right, rgb(22, 115, 202), #0aa1ed) 1 10;
      cursor: pointer;
    }

    .navbar-nav {
      float: right !important;
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1199px) {
    .header-container {
      padding-top: 40px;
    }

    .img-responsives {
      width: 150px;
      height: 60px;
    }

    .header-top-font-symbol {
      display: none;
    }

    .header-top-left {
      height: 80px;
      line-height: 0;
    }

    .header-top-left-img-font {
      padding-top: 5px;
    }

    .header-top-font-symbol {
      display: none;
    }

    .header-top-left-font-style {
      height: 80px;
      font-size: 18px;
    }

    .nav-item {
      width: 130px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    .min-liHome {
      // padding-top: 30px;
      font-size: 18px;
      color: #bbb;
    }

    .min-liHome:hover {
      border-bottom: 6px transparent solid;
      border-image: linear-gradient(to right, rgb(22, 115, 202), #0aa1ed) 1 10;
      cursor: pointer;
    }

    .navbar-nav {
      float: right !important;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
    .navbar-toggle {
      display: block !important;
    }

    .header-container {
      padding-top: 30px;
    }

    .img-responsives {
      width: 100px;
      height: 40px;
    }

    .header-top-left {
      height: 80px;
      line-height: 0;
    }

    .header-top-left-img-font {
      padding-top: 5px;
    }

    .header-top-font-symbol {
      display: none;
    }

    .header-top-left-font-style {
      height: 80px;
      font-size: 18px;
    }

    .navbar-nav {
      float: none;
    }

    .nav-item {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center !important;
    }

    .min-right-first-ul li {
      border-bottom: 1px solid #ddd;
    }

    .min-liHome {
      // padding-top: 20px;
      font-size: 15px;
      color: #bbb;
    }

    .min-liHome:hover {
      color: #fff;
      cursor: pointer;
    }

    .navbar-collapse {
      padding: 0 !important;
      background-color: #666 !important;
      border-radius: 30px !important;
      text-align: center !important;
    }

    .nav-item {
      text-align: center !important;
    }
  }

  @media screen and (max-width: 767px) {
    .navbar-toggle {
      display: block !important;
    }

    .header-container {
      padding-top: 30px;
    }

    .img-responsives {
      width: 100px;
      height: 40px;
    }

    .header-top-left {
      height: 80px;
      line-height: 0;
    }

    .header-top-left-img-font {
      padding-top: 5px;
    }

    .header-top-font-symbol {
      display: none;
    }

    .header-top-left-font-style {
      height: 80px;
      font-size: 18px;
    }

    .navbar-nav {
      float: none;
    }

    .nav-item {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: left;
    }

    .min-right-first-ul li {
      border-bottom: 1px solid #ddd;
    }

    .min-liHome {
      // padding-top: 15px;
      font-size: 15px;
      color: #bbb;
    }

    .navbar-collapse {
      width: 10%;
      padding-bottom: 15px !important;
      background-color: #666 !important;
      border-radius: 5px !important;
      text-align: center !important;
    }

    .nav-item {
      text-align: center !important;
    }
  }

  .active {
    color: #fff;
  }

  .show-containr {
    display: block;
  }

  .hidden-container {
    display: none;
  }
</style>